var React = require('react');

function Mountains (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_133","data-name":"Path 133","d":"M4363.1,5378.373h14.687a.747.747,0,0,0,.589-1.206l-11.811-15.158a.747.747,0,0,0-1.178,0l-2.244,2.88a5.539,5.539,0,0,0-9.344-.832l-4.186-5.547a.748.748,0,0,0-1.193,0l-14.082,18.666a.748.748,0,0,0,.6,1.2H4363.1Zm-14.083-18.172,12.583,16.678h-25.166Zm13.073,6.04-3.376,4.332-3.969-5.261a4.053,4.053,0,0,1,7.345.929m1.382,10.638-3.826-5.071,6.33-8.124,10.281,13.195Z","transform":"translate(-4334.188 -5358.213)","fill":"#fff"}));
}

Mountains.defaultProps = {"width":"44.346","height":"20.16","viewBox":"0 0 44.346 20.16"};

module.exports = Mountains;

Mountains.default = Mountains;
